export const RateTypeShippingEnum = {
  RETAIL: 'retail',
  COLLECT: 'collect'
}
